import { render, staticRenderFns } from "./Editspend.vue?vue&type=template&id=089e6f98&"
import script from "./Editspend.vue?vue&type=script&lang=js&"
export * from "./Editspend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports